import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function Dashboard() {
  const { t } = useTranslation(['dashboard', 'common']);

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('common:menu.dashboard')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('dashboard:summary')}
        </Typography>
      </Box>
    </>
  );
}
